module.exports = __webpack_public_path__ + "img/yellow_alert.cfb5af0d.svg";